export const DRAG_AND_DROP_PRODUCT = "DRAG_AND_DROP_PRODUCT";
////////////////////////////////////

// Featured listing
export const GET_FEATURED_LIST = "GET_FEATURED_LIST";
export const GET_FEATURED_LIST_SUCCESS = "GET_FEATURED_LIST_SUCCESS";
export const GET_FEATURED_LIST_ERROR = "GET_FEATURED_LIST_ERROR";

// Edit Featured
export const EDIT_FEATURED = "EDIT_FEATURED";
export const EDIT_FEATURED_SUCCESS = "EDIT_FEATURED_SUCCESS";
export const EDIT_FEATURED_ERROR = "EDIT_FEATURED_ERROR";

// Add Featured
export const ADD_FEATURED = "ADD_FEATURED";
export const ADD_FEATURED_SUCCESS = "ADD_FEATURED_SUCCESS";
export const ADD_FEATURED_ERROR = "ADD_FEATURED_ERROR";

// delete
export const DELETE_FEATURED = "DELETE_FEATURED";
export const DELETE_FEATURED_SUCCESS = "DELETE_FEATURED_SUCCESS";
export const DELETE_FEATURED_ERROR = "DELETE_FEATURED_ERROR";